import React from 'react';

export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({
  sm,
  md,
  lg,
}: {
  sm: number;
  md: number;
  lg: number;
}) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

declare module '@mui/material/styles' {
  interface TypographyVariants {
    fontWeightSemiBold: React.CSSProperties['fontWeight'];
    body3: React.CSSProperties;
    body4: React.CSSProperties;
    body5: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    body3: React.CSSProperties;
    body4: React.CSSProperties;
    body5: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    subtitle1: false;
    subtitle2: false;
    caption: false;
    button: false;
    overline: false;
    body1: true;
    body2: true;
    body3: true;
    body4: true;
    body5: true;
  }
}

export const primaryFont = 'Public Sans, sans-serif'; // Google Font

export const typography = {
  fontFamily: primaryFont,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    lineHeight: pxToRem(90),
    fontSize: pxToRem(72),
    letterSpacing: '-2%',
  },
  h2: {
    fontWeight: 700,
    lineHeight: pxToRem(72),
    fontSize: pxToRem(60),
    letterSpacing: '-2%',
  },
  h3: {
    fontWeight: 700,
    lineHeight: pxToRem(60),
    fontSize: pxToRem(48),
    letterSpacing: '-2%',
  },
  h4: {
    fontWeight: 700,
    lineHeight: pxToRem(44),
    fontSize: pxToRem(36),
  },
  h5: {
    fontWeight: 700,
    lineHeight: pxToRem(38),
    fontSize: pxToRem(30),
  },
  h6: {
    fontWeight: 700,
    lineHeight: pxToRem(20),
    fontSize: pxToRem(16),
  },
  body1: {
    lineHeight: pxToRem(30),
    fontSize: pxToRem(20),
    fontWeight: 500,
  },
  body2: {
    lineHeight: pxToRem(24),
    fontSize: pxToRem(16),
    fontWeight: 500,
  },
  body3: {
    lineHeight: pxToRem(20),
    fontSize: pxToRem(14),
    fontWeight: 500,
  },
  body4: {
    lineHeight: pxToRem(18),
    fontSize: pxToRem(12),
    fontWeight: 500,
  },
  body5: {
    lineHeight: pxToRem(12),
    fontSize: pxToRem(10),
    fontWeight: 500,
  },
} as const;
